<div class="container">
  <div class="products__title">Services needed in {{ selectedMemberRegion }}</div>
  <div class="roles-count w-100">
    <div class="card-sub-cate" (click)="selectAll()" [ngClass]="{ active: areAllSelected }">
      <div class="card-sub-cate__title mb-0">
        All
      </div>
    </div>

    <div *ngFor="let role of rolesCount" (click)="selectRole(role)" [ngClass]="{ active: role.selected }"
      class="card-sub-cate">
      <div>
        <div class="product-count">( {{ role.serviceCounts || 0 }} )</div>
        <div class="card-sub-cate__title">
          {{ role.roleName | titlecase }}
        </div>
      </div>
    </div>

  </div>
  <div class="products__nav">
    <div class="search">
      <i class="fa-solid fa-magnifying-glass"></i>
      <input type="text" (keyup)="handleSearch($event)" />
    </div>
  </div>
  <div class="products">
    @if(loading){
    <div class="card-skeleton" *ngFor="let item of [1, 1, 1, 1, 1]">
      <div class="image-placeholder"></div>
      <div class="content-placeholder">
        <div class="title-placeholder"></div>
        <div class="desc-placeholder"></div>
      </div>
    </div>
    }@else{ @for(list of allProduct.data;track list){
    <common-product-card-view (view)="viewProductDetails($event)" [list]="list"
      [isCommunityProduct]="true"></common-product-card-view>
    } @empty {
    <div class="no-product">
      <div class="no-product__title">You don't have Services in your region</div>
      <button class="my-button-3" (click)="openShopPopup('bless')">Add Services</button>
    </div>
    }
    <common-product-card-view (view)="viewProductDetails($event)" *ngFor="let list of adsList" [list]="list"
      [ads]="true" [isCommunityProduct]="true"></common-product-card-view>
    }
  </div>

  @if(isLoadingAllProductMore) {
  <div class="loader xs"></div>
  } @else {
  <div class="w-100 d-flex justify-content-center" *ngIf="allProduct.currentPage < allProduct.lastPage">
    <div (click)="_getMemberShopProduct(allProduct.currentPage + 1); isLoadingAllProductMore = true" class="show-more">
      Show More <i class="fa-solid fa-chevron-down"></i>
    </div>
  </div>
  }
</div>
<app-marketplace #marketplace [share]="true"></app-marketplace>